module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_03_6DE79_1SF_HZK.529114b9.jpg";